import { FormValidationType } from "../../../../types";
import { FILE_ATTACHMENTS_CONSTANTS } from "../../../../constants";

export const formValidation: FormValidationType = {
  [FILE_ATTACHMENTS_CONSTANTS.PHOTOS]: {
    required: { value: false },
  },
  [FILE_ATTACHMENTS_CONSTANTS.DOCUMENTS]: {
    required: { value: false },
  },
};
